window.$ = window.jQuery = require('jquery');
$.mask = window.mask = require('jquery-mask-plugin');

window.conf = require('../../../config.json');
//window.conf = require('../../../../public/lp/' + getCookie('projeto') + '/config.json');
require('bootstrap/js/dist/modal');
require('owl.carousel');

// require('./components/safetymails');
const gmaps = require('./components/gmaps');
const $window = $(window);
let PhotoSwipe = require('photoswipe');
let PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default.js');
let scroll1, scroll2;


// READY
$(function () {

	// EVENTO SCROLL
	scroll1 = $window.scrollTop();
	scrollw($window.scrollTop());
	$window.on('scroll', function () { scrollw($(this).scrollTop()); });

	// RESIZE
	resizeWindow();
	$(window).on('resize', resizeWindow);

	// BT MENU
	$('.bt-menu').on('click', function () {
		$('body').toggleClass('menu-open');
	});

	// BG COVER IF IE
	if (document.all || document.documentMode == 11) {
		$('.img-cover img').each(function (i, el) {
			var src = $(el).data('src') == undefined ? $(el).attr('src') : $(el).data('src');
			$(el).hide().parent().css({ 'background-image': 'url(' + src + ')', 'background-size': 'cover', 'background-position': 'center' });
		})
	}

	// NAVEGACAO ANCORA
	$('a[href^="#"]:not(.open-modal)').on('click', function (e) {
		var hash = $(this).attr("href"),
			el = $(hash),
			pos = 0;

		if (hash.length <= 1) return;

		var el = $(hash),
			pos = 0;

		if (el.length > 0) {
			e.preventDefault();
			pos = el.offset().top;
			el.attr("id", "");

			$("body").removeClass("menu-open");

			$("body,html").animate({ scrollTop: pos }, 500, function () {
				location.hash = hash;
				el.attr("id", hash.replace("#", ""));
			});
		}
	})

	$('header .logo img').on('click', function (e) {
		$('body').removeClass('menu-open');
		$('body,html').animate({ scrollTop: 0 }, 500);
	})

	// BT VIDEO
	$('.btn-play').on('click', function (e) {
		e.preventDefault();
		$(this).parent().addClass('playing').siblings('iframe').attr('src', function () {
			return $(this).data('src');
		});
	});

	// CARROSSEL
	$('.banner .owl-carousel').owlCarousel({
		items: 1,
		nav: false,
		dots: false,
		lazyLoad: true,
		loop: true,
		autoplay: true,
		mouseDrag: false,
		touchDrag: false,
		animateIn: 'fadeIn',
		animateOut: 'fadeOut'
	});	

	$('.galeria.owl-carousel').each(function (i, el) {
		var itens = parseInt($(this).data('itens')),
			infinita = $(this).hasClass('galeria-tipo-2'),
			btn_nav = $(this).parents('section').hasClass('lazer') ? 'btn-navlazer' : 'btn-navapto';

		itens = itens == undefined ? 1 : itens

		$(el).owlCarousel({
			margin: 15,
			dots: false,
			navClass: ['prev icon-nav-prev btn ' + btn_nav, 'next icon-nav-next btn ' + btn_nav],
			navText: '',
			lazyLoad: true,
			onLoadLazy: function (e) {
				e.element.parents('.owl-item').addClass('owl-load');
			},
			onLoadedLazy: function (e) {
				e.element.parents('.owl-item').removeClass('owl-load');
			},
			responsive: {
				0: {
					stagePadding: 15,
					lazyLoadEager: 1,
					items: 1,
					slideBy: 1
				},
				768: {
					items: itens,
					slideBy: itens,
					lazyLoadEager: 0,
					lazyLoadEager: infinita ? 1 : 0,
					loop: false,
					margin: infinita ? 30 : 15,
					nav: true,
					stagePadding: 0
				}
			}
		});
	});

	$('.plantas .owl-carousel').each(function (i, el) {
		$(el).owlCarousel({
			items: 1,
			margin: 15,
			nav: false,
			dots: true,
			autoHeight:true,
			navClass: ['prev btn btn-navplantas icon-nav-prev', 'next btn btn-navplantas icon-nav-next'],
			navText: '',
			lazyLoad: true,
			onLoadLazy: function (e) {
				e.element.parents('.owl-item').addClass('owl-load');
			},
			onLoadedLazy: function (e) {
				e.element.parents('.owl-item').removeClass('owl-load');
			},
			responsive: {
				768: {
					nav: true,
					dots: false
				}
			}
		});
	});

	// AMPLIAR IMG
	$('.zoom').on('click', function (e) {
		e.preventDefault();
		var $this = $(this),
			grupo = $this.data('grupo'),
			items = new Array(),
			index = $this.data('index');

		$itens = $(':not(.cloned) .zoom[data-grupo="' + grupo + '"]');
		$itens = $itens.length == 0 ? $this : $itens;

		$itens.each(function (i, el) {
			var $el = $(el),
				$href = $el.attr('href'),
				$size = $el.data('size').split('x'),
				$width = $size[0],
				$height = $size[1];

			if ($el.parents('.cloned').length > 0) return;

			var item = {
				src: $href,
				w: $width,
				h: $height,
				title: $el.parent().find('figcaption').text()
			}

			items.push(item);
		})

		var pswpElement = document.querySelectorAll('.pswp')[0];

		var options = {
			index: index,
			closeOnScroll: false,
			loop: false,
			errorMsg: '<div class="pswp__error-msg">Imagem não encontrada. <a href="%url%" target="_blank">Clique aqui</a> para abrir em uma nova aba.</div>'
		};

		var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();
	})

	// ABAS PLANTAS
	$('.abas-plantas button[data-item]').on('click', function () {
		var item = $(this).data('item');
		var $abas = $(this).parents('.abas-plantas');

		if ($(this).hasClass('btn-primary') && $window.width() <= 768) {
			$('button[data-item]', $abas).removeClass('btn-navplantas').addClass('btn-outline-navplantas');
			$('.conteudo .item-aba', $abas).removeClass('active');
		} else {
			$('button[data-item]', $abas).removeClass('btn-navplantas').addClass('btn-outline-navplantas');
			$('.conteudo .item-aba', $abas).removeClass('active');
			$('button[data-item=' + item + ']', $abas).removeClass('btn-outline-navplantas').addClass('btn-navplantas');
			$('.conteudo .item-aba[data-item=' + item + ']', $abas).addClass('active');
		}

	})

	// ABRIR MODAL
	$('.open-modal').on('click', function (e) {
		e.preventDefault();

		var target = $(this).data('modal-target');

		$(target).addClass('modal-show');

		if (target == '.modal-video') {
			var src = $('.modal-video iframe').data('src');
			$('.modal-video iframe').attr('src', src);
		}
	})
	$('.modal-custom .bt-fechar, .modal-custom .bg').on('click', function () {
		$(this).parents('.modal-custom').removeClass('modal-show').find('.box-mensagem-ativo .btn').trigger('click');
		$('.modal-video iframe').removeAttr('src');
	})

	// MASCARA TEL
	$('input[type=tel]:not(:disabled)').each(function (i, el) {
		$(el).mask(SPMaskBehavior, spOptions);
	})

	// TEXTAREA AUTO-EXPAND
	$('textarea').on('scroll keyup', function (e) {
		this.style.height = this.scrollHeight + 2 + 'px';
	})

	// API SAFETYMAILS
	if (conf.safetymails.ticket_origem != '') {
		$('input[type=email]').parents('form').safetymails();
	}

	// VALIDACAO REALTIME
	$('.form-control, .custom-select').on('blur', function () {
		$form = $(this).parents('form');

		if ($(this).is(':valid'))
			$(this).removeClass('is-invalid').addClass('is-valid');
		else
			$(this).removeClass('is-valid').addClass('is-invalid');
	})

	// FORMA DE CONTATO ALTERNA TEL REQUIRED
	$('#FE_Contato').on('change', function () {
		var label = $('#FE_Tel').attr('name');
		if ($(this).val() == 'Email') {
			$('#FE_Tel').prop('required', false).prev().find('span').show();
		} else {
			$('#FE_Tel').prop('required', true).prev().find('span').hide();
		}
	})

	// VALIDAÇÃO FORMULÁRIO
	$('#formEmail, #formChat, #formWhats').on('submit', function () {
		var $form = $(this),
			tipo = $form.data('tipo');

		if (this.checkValidity()) {
			evento('Contato', 'Enviar ' + tipo);
		} else {
			$form
				.addClass('was-validated')
				.find(':invalid').each(function (i, el) {
					evento('Contato', 'Erro', $(el).siblings('.invalid-feedback').text())
				});
		}
	})

	// FECHA MODAIS - TECLA ESC 
	$(document).on('keydown', function (e) {
		var tecla = e.keyCode;
		if (tecla == 27) {
			$('body').removeClass('amplia-mapa');
			$('.modal-custom').removeClass('modal-show');
		}

	});

	// PARALLAX IMG
	$('.img-parallax').each(function (i, el) {

		function parallaxImg() {
			var speed = parseFloat($(el).data('speed')) + 1;
			var winY = $(window).scrollTop();
			if (winY > $(el).height()) return;

			$(el).css({
				transform: 'translate3d(0,' + (winY / speed) + 'px, 0)'
			});
		}
		$(document).on({
			scroll: function () {
				parallaxImg();
			}, ready: function () {
				parallaxImg();
			}
		});
	});

	// API GMAPS
	if (conf.template.localizacao.api) {
		gmaps.init();
	}

})

// FUNCTION RESIZE WINDOW
function resizeWindow() {
	$('.galeria-tipo-3').each(function (i, el) {
		galeriaBlocos(el);
	})

	$('.plantas .lista-plantas').each(function (i, el) {
		if ($window.width() >= 1024) {
			$(el)
				.removeClass('owl-carousel')
				.trigger('destroy.owl.carousel');
		} else {
			$(el)
				.addClass('owl-carousel')
				.owlCarousel({
					items: 1,
					margin: 15,
					nav: false,
					dots: true,
					lazyLoad: true,
					onLoadLazy: function (e) {
						e.element.parents('.owl-item').addClass('owl-load');
					},
					onLoadedLazy: function (e) {
						e.element.parents('.owl-item').removeClass('owl-load');
					}
				});
		}
	});
}

// FUNCOES SCROLL
function scrollw(top) {

	// BARRA FIXA SCROLLBACK
	scroll2 = top;
	if (top > 60 && conf.template.header.tipo == 2) {
		if (scroll2 < scroll1) {
			$('header.header-hide').removeClass('header-hide');
		} else {
			$('header:not(.header-hide)').addClass('header-hide');
		}
	}
	scroll1 = top;

	// BARRA FIXA
	if (conf.template.header.tipo != 1) {
		if (top > 60) {
			$('header.header-fixo:not(.header-bg)').addClass('header-bg');
		} else {
			$('header.header-bg').removeClass('header-bg');
		}
	}

	// CONVERSAO
	if (top > 100) {
		$('.conversao.hide').removeClass('hide');
	} else {
		$('.conversao').addClass('hide');
	}

}


// GALERIA MOSAICO
function galeriaBlocos(el) {
	$(el).show();
	if ($window.width() >= 768) {
		$(el)
			.removeClass('galeria owl-carousel')
			.trigger('destroy.owl.carousel')
			.addClass('galeria-blocos');
	} else {
		$(el)
			.addClass('galeria owl-carousel')
			.owlCarousel({
				items: 1,
				dots: false,
				lazyLoad: true,
				lazyLoadEager: 1,
				stagePadding: 15,
				margin: 15,
				onLoadLazy: function (e) {
					e.element.parents('.owl-item').addClass('owl-load');
				},
				onLoadedLazy: function (e) {
					e.element.parents('.owl-item').removeClass('owl-load');
				}
			})
			.removeClass('galeria-blocos');
	}
}


// FUNCTION ALTERNA MASCARA TEL
var SPMaskBehavior = function (val) {
	return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
},
	spOptions = {
		clearIfNotMatch: true,
		onKeyPress: function (val, e, field, options) {
			field.mask(SPMaskBehavior.apply({}, arguments), options);
		}
	};

// Event Tracking
window.evento = function (category, action, label) {
	try {
		gtag("event", action, { event_category: category, event_label: label });
	} catch (e) {
		console.warn("GA não instalado");
	}
};


// Integração HUBID
function hubidBoxMensagem(form) {
	var $form = $(form);

	if ($form.siblings('.box-mensagem').length == 0) {
		$form.after('<div class="box-mensagem"></div>');
	}

	var box_msg = $form.siblings('.box-mensagem');

	box_msg.off('click', '.btn').on('click', '.btn', function (e) {
		e.preventDefault();
		box_msg.removeClass('box-mensagem-ativo');
		setTimeout(function () { box_msg.html(''); }, 200);
	});

	return box_msg;
}

function hubidAtualizaBoxMensagem(box_msg, titulo, texto) {
	var html = '<div class="box-mensagem-ok">' +
		'<span class="box-mensagem-tit">' + titulo + '</span>' +
		'<span class="box-mensagem-texto">' + texto + '</span>' +
		'<a href="" class="btn btn-form">Voltar</a>' +
		'</div>';
	box_msg.html(html);
	box_msg.removeClass('box-mensagem-load');
}

var hubidUltimoForm = null;

function hubidFormDoCanal(channel) {
	if (hubidUltimoForm) return $(hubidUltimoForm);
	if (channel === 'whatsapp') return $('#formWhats');
	if (channel === 'chat') return $('#formChat');
	return $('#formEmail');
}

// Escolher "Whatsapp" no select do formulário de e-mail faz o tracker abrir o WhatsApp após o envio
$(document).on('change', '#FE_Contato', function () {
	var $form = $('#formEmail');
	if ($(this).val() === 'Whatsapp') {
		$form.attr('data-hubid-channel', 'whatsapp');
	} else {
		$form.removeAttr('data-hubid-channel');
	}
});

$(document).on('submit', 'form[data-hubid-form]', function () {
	hubidUltimoForm = this;
	hubidBoxMensagem(this).addClass('box-mensagem-load box-mensagem-ativo');
});

window.addEventListener('hubid:lead_success', function (e) {
	var channel = e.detail.channel;
	var $form = hubidFormDoCanal(channel);
	var tipo = $form.data('tipo');
	var box_msg = hubidBoxMensagem($form);

	if ($form.closest('.modal-custom').length) {
		box_msg.html('').removeClass('box-mensagem-load box-mensagem-ativo');
		$('.modal-show .bt-fechar').trigger('click');
	} else {
		hubidAtualizaBoxMensagem(box_msg, 'Recebemos seu contato!', 'Aguarde nosso retorno em breve.');
	}

	evento('Contato', 'Sucesso ' + tipo);

	if (typeof fbq !== 'undefined') {
		fbq('track', 'Lead');
	}
});

window.addEventListener('hubid:lead_error', function (e) {
	var $form = hubidFormDoCanal(e.detail.channel);
	var box_msg = hubidBoxMensagem($form);
	hubidAtualizaBoxMensagem(box_msg, 'Falha no envio', 'Não foi possível enviar seu contato. Tente novamente em instantes.');
});